import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
import { SpookyWord } from './SpookyWord';
interface HeaderProps {
  onScrollToCatalog?: () => void;
  onBusinessOrder?: () => void;
  onBookTable?: () => void;
  onJobs?: () => void;
}
export function Header({
  onScrollToCatalog,
  onBusinessOrder,
  onBookTable,
  onJobs
}: HeaderProps) {
  return <header className="w-full pt-12 pb-20 md:pt-16 md:pb-32 flex flex-col items-center px-4" data-id="element-639" data-mp="2rmf9zmbdvhmt">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative w-full max-w-[500px] mb-10" data-id="element-640" data-mp="2wl8o9gyhvco1">
        <img src="https://cdn.magicpatterns.com/uploads/qmwBa2tP2vciePEfbWYRRk/top_notch_logga.png" alt="Top Notch Bakery Logo" className="w-full h-auto object-contain drop-shadow-sm" data-id="element-641" data-mp="3bael4y9v0qsr" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2,
      ease: 'easeOut'
    }} className="text-center mb-12 md:mb-14 max-w-4xl px-2 sm:px-4" data-id="element-642" data-mp="2wlm7vbyte0iu">
        <p className="font-serif text-[1.75rem] leading-[1.25] sm:text-4xl md:text-5xl md:leading-[1.15] text-[#1A1A1A] tracking-tight" data-id="element-643" data-mp="2hpy5lsd23nhl">
          Hos oss hittar du nybakat{' '}
          <SpookyWord monster="spökbröd" delay={2.5} every={11} data-id="element-644" data-mp="3ad11ecqclk45">
            bröd
          </SpookyWord>
          , kreativa{' '}
          <SpookyWord monster="monsterverk" delay={5.5} every={13} data-id="element-645" data-mp="30mpo3zkrxykl">
            bakverk
          </SpookyWord>{' '}
          och vällagad{' '}
          <SpookyWord monster="häxbrygd" delay={8.5} every={12} data-id="element-646" data-mp="1x7mg2bo0gp7">
            mat
          </SpookyWord>{' '}
          –{' '}
          <em className="italic text-[#7C8062]" data-id="element-647" data-mp="3t90md3kwrne8">
            alltid gjort från{' '}
            <SpookyWord monster="graven" delay={11} every={14} data-id="element-648" data-mp="1re349pwrkid8">
              grunden
            </SpookyWord>
            .
          </em>
        </p>
        <div className="mx-auto mt-7 md:mt-9 w-12 h-px bg-[#C4993D]" data-id="element-649" data-mp="1ho1l9cj9pq56" />
        <p className="mt-7 md:mt-9 mx-auto max-w-2xl text-lg md:text-xl leading-relaxed text-[#1A1A1A]/75" data-id="element-650" data-mp="1hlxgksdjon3u">
          Vi drivs av{' '}
          <span className="font-serif italic text-[#1A1A1A]" data-id="element-651" data-mp="18mk2fmeh7acs">
            <SpookyWord monster="skräck" delay={7} every={15} data-id="element-652" data-mp="18pg4nmxcwl71">
              nyfikenhet
            </SpookyWord>
          </span>
          ,{' '}
          <span className="font-serif italic text-[#1A1A1A]" data-id="element-653" data-mp="ypp4p5q11dzk">
            hantverksskicklighet
          </span>{' '}
          och en genuin{' '}
          <span className="font-serif italic text-[#C4993D]" data-id="element-654" data-mp="13q382agonzr9">
            kärlek till det vi skapar
          </span>
          .
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center gap-5 w-full max-w-2xl mb-20 md:mb-32" data-id="element-655" data-mp="2y0yqs5ll0v7r">
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full justify-center" data-id="element-656" data-mp="rdrbqrxwnpuz">
          <button onClick={onScrollToCatalog} className="w-full sm:w-auto px-8 py-3.5 bg-[#C4993D] text-[#F2EDE4] rounded-full font-medium text-sm hover:bg-[#A8832F] transition-colors shadow-sm" data-id="element-657" data-mp="rbwsrj6727tj">
            Förbeställning Privat
          </button>
          <button onClick={onBusinessOrder} className="w-full sm:w-auto px-8 py-3.5 bg-transparent border-2 border-[#C4993D] text-[#C4993D] rounded-full font-medium text-sm hover:bg-[#C4993D]/10 transition-colors" data-id="element-658" data-mp="1f197eykaj838">
            Företagsbeställning
          </button>
          <button onClick={onBookTable} className="w-full sm:w-auto px-8 py-3.5 bg-[#7C8062] text-[#F2EDE4] rounded-full font-medium text-sm hover:bg-[#6A6D53] transition-colors shadow-sm" data-id="element-659" data-mp="3bxov3tets0bb">
            Boka Bord
          </button>
        </div>
        <button onClick={onJobs} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent border-2 border-[#7C8062] text-[#7C8062] rounded-full font-medium text-sm hover:bg-[#7C8062] hover:text-[#F2EDE4] transition-colors" data-id="element-660" data-mp="2cxctwo7lt3hv">
          <Briefcase className="w-4 h-4" data-id="element-661" data-mp="1p7s9e0vsxy6h" />
          Jobba hos oss
        </button>
      </motion.div>

      {/* Editorial Image Grid */}
      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start" data-id="element-662" data-mp="1xzkgc1lmap6b">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="w-full" data-id="element-663" data-mp="11ho65umj00g0">
          <img src="https://cdn.magicpatterns.com/uploads/fKFpEdf5PFAj8HiGFNH4Ae/0AC39895-57D5-4F1D-BFC8-B4D1341FF8F6.png" alt="Top Notch Bakery Counter" className="w-full aspect-[3/4] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-664" data-mp="t0fi3xdpr9yg" />
        </motion.div>

        <div className="w-full flex flex-col gap-6 md:gap-8 md:mt-16" data-id="element-665" data-mp="f1o8oo9sqcgn">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.8,
          ease: 'easeOut'
        }} data-id="element-666" data-mp="a9o067fnub8g">
            <img src="https://cdn.magicpatterns.com/uploads/fydJovVoiB1VDRERSZCu7c/77E18535-8EC5-4A5D-842C-07BE6F7121F8.png" alt="Top Notch Bakery Chocolate Display" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-667" data-mp="3sehkqk3cp8ak" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 1.0,
          ease: 'easeOut'
        }} data-id="element-668" data-mp="3ipu5h6i9h0h8">
            <img src="https://cdn.magicpatterns.com/uploads/uqyo82xEXsx7htA4oPJVbw/8D11E304-9909-41BA-83B2-2DFA1C7F7BBD.png" alt="Top Notch Bakery Kanelbullar & Munkar" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-669" data-mp="5dtpnhq1hbr7" />
          </motion.div>
        </div>
      </div>
    </header>;
}